module.exports = function getResource(label, vars = []) {
    let resources = {
        pickupNotOffered: ' - Pickup not offered',
        openUntil: `Open until ${vars[0]}`,
        closed: 'Closed',
        milesAway: ' miles away',
        inStock: 'In Stock',
        outOfStock: 'Out of Stock',
        limitedStock: 'Limited Stock',
        payInStore: 'Pay in Store',
        payOnline: 'Pay Online'
    };

    return resources[label];
};
